import requestor from "../../requestor";

export default class DiscountApi {
  all = (page = 1, name = null, item_id = null) =>
    requestor.get("/discount/all", {
      page: page,
      filter: {
        name: name,
        item_id: item_id,
      },
    });
  one = (id) => requestor.get("/discount/one", { id: id });
  create = () => requestor.post("/discount/create");
  save = (form) => requestor.patch("/discount/save", { Discount: form });
  remove = (id) => requestor.delete("/discount/delete", { id: id });
  common = () => requestor.get("/discount/common");
}
